import { gql, useMutation } from "@apollo/client";
import {
  MediaFile,
  MutationUploadMediaFileArgs,
} from "../../__generated__/types";
const UPLOAD_MEDIA_FILE_MUTATION = gql`
  mutation UploadMediaFile($userId: ID!, $path: String!, $url: String, $title: String, $credit: String, $description: String) {
    uploadMediaFile(userId: $userId, path: $path, url: $url, title: $title, credit: $credit, description: $description) {
      _id
      name
      path
      url
      userId
      title
      credit
      description
    }
  }
`;

export const useUploadMediaFileMutation = () => {
  const [uploadMediaFileMutation, { loading, error, data }] = useMutation(
    UPLOAD_MEDIA_FILE_MUTATION
  );

  const uploadMediaFile = async (
    args: MutationUploadMediaFileArgs
  ): Promise<MediaFile> => {
    try {
      const result = await uploadMediaFileMutation({
        variables: args,
      });
      return result?.data?.uploadMediaFile;
    } catch (err) {
      console.error("Error uploading media file:", err);
      throw err;
    }
  };

  return { uploadMediaFile, loading, error, data };
};
